import React, { useEffect } from 'react';
import styles from './ConfirmDialog.module.css';
import { TrashIcon, AlertTriangleIcon } from '../Icon';

const ConfirmDialog = ({
    show,
    isOpen,
    onClose,
    onConfirm,
    title = 'Удалить объект?',
    message,
    confirmLabel = 'Удалить',
    cancelLabel = 'Отмена',
    destructive = true,
    icon,
    loading = false
}) => {
    const isVisible = show ?? isOpen;

    useEffect(() => {
        if (!isVisible) return;

        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && !loading) {
                onClose?.();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isVisible, loading, onClose]);

    if (!isVisible) return null;

    const handleConfirm = () => {
        if (!loading && onConfirm) {
            onConfirm();
        }
    };

    const defaultIcon = destructive ? <TrashIcon size={24} /> : <AlertTriangleIcon size={24} />;

    return (
        <div className={styles.confirmOverlay} onClick={() => !loading && onClose?.()}>
            <div
                className={styles.confirmModal}
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
            >
                <div className={`${styles.confirmIconWrapper} ${!destructive ? styles.iconWarning : ''}`}>
                    {icon || defaultIcon}
                </div>
                <h3 className={styles.confirmTitle}>{title}</h3>
                {message && (
                    <div className={styles.confirmMessage}>
                        {typeof message === 'string' ? <p>{message}</p> : message}
                    </div>
                )}
                <div className={styles.confirmActions}>
                    <button
                        type="button"
                        className={styles.confirmCancelBtn}
                        onClick={onClose}
                        disabled={loading}
                    >
                        {cancelLabel}
                    </button>
                    <button
                        type="button"
                        className={`${styles.confirmDeleteBtn} ${!destructive ? styles.confirmPrimaryBtn : ''}`}
                        onClick={handleConfirm}
                        disabled={loading}
                    >
                        {loading ? 'Удаление...' : confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;

